<template>
  <div class="centerIntro-wrap">
    <div class="centerIntro-content">
      <Breadcrumb :options="crumbOptions"></Breadcrumb>
      <div class="title">{{ detailContent.title }}</div>
      <div class="summary">
        <span v-if="detailContent.provider">{{intro}}：{{ detailContent.provider }}</span
        ><span>时间：{{ detailContent.createTime }}</span>
      </div>
      <div class="content">
        <div v-html="detailContent.content"></div>
        <div class="downClass" v-if="detailContent.appendixFile">
          <div>附件：</div>
          <div
            v-for="item in detailContent.appendixFile"
            :key="item.fileId"
            class="downDiv"
          >
            <div>
              <span class="name">{{ item.fileName }}</span>
              <a-icon class="icon" type="download" @click="downClick(item)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import { getCurrentCrumb } from '@/utils/crumb.js'
import { downFile } from '@/api/home'
import { queryIntellectual } from '@/api/IntellectualSchool'

export default {
  data() {
    return {
      crumbOptions: [],
      detailContent: {},
      intro: ''
    }
  },
  components: {
    Breadcrumb
  },
  created() {
    this.settingCrumb()
    this.init()
  },
  methods: {
    async init() {
      const { id, selectedId } = this.$route.query
      switch (selectedId) {
        case '1':
          this.intro = '提供人'
          break;
        case '4':
          this.intro = '教学团队/任课教师'
          break;
        case '5':
          this.intro = '提供人'
          break;
        default:
          this.intro = '主讲人'
          break;
      }
      const { data } = await queryIntellectual(id)
      this.detailContent = data
    },
    settingCrumb() {
      const { path } = this.$route
      const crumbOptions = getCurrentCrumb(path)
      this.crumbOptions = crumbOptions
    },
    async downClick(item) {
      const data = await downFile(item.id)
      const blob = new Blob([data])
      const elink = document.createElement('a')
      elink.download = item.fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    }
  }

}
</script>
